module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAK5JREFUOE/dU9ENAiEMLV1ER/Em8aBhDs85SINucqPoItXrBYjRE4kXf3wJNJT2pbxSAwkxxq2I7PP5g70S0UljjG7M3APAAQDUOaS1xJHvehGx3vsxE2gyENGRmW+Tnf3PyHeTLfFLBBEAtKIXGGNG51xXJWjR4LcEtW4g4tlae6lWUCNQkVPX3ou4WoM/eMJqDb4iCCHsEFG/8DxhDRhEpCvD9DCRm4ZkDSnjfAdTmawRH9FtHwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImage/workOrder.png
// module id = lK5g
// module chunks = 3